// The breakpoints (WI 5799). Each value is the first width of the wider layout,
// so "below" a breakpoint means `width < value`: 768px (iPad portrait) is still
// below md. theme.ts generates the SASS variables from these values, and the
// mixins below(), from() and between() in helpers.scss write the same media
// queries as this module.

import { useMediaQuery } from '@vueuse/core';

export const breakpoints = {
  // the side nav docks, table views are allowed
  sm: 600,
  // two-column layouts
  md: 769,
  // the map route is allowed (project and template routes)
  map: 800,
  // the side nav may be expanded
  'nav-full': 920,
  // desktop: board, List|Board switcher, map links, dialogs instead of full screen
  lg: 1000,
} as const;

export type Breakpoint = keyof typeof breakpoints;

function belowQuery(name: Breakpoint) {
  return `(width < ${breakpoints[name]}px)`;
}

/** True while the viewport is narrower than the breakpoint; follows resizes. */
export function useViewportBelow(name: Breakpoint) {
  return useMediaQuery(belowQuery(name));
}

/** The same check once, for router guards and event handlers. */
export function isViewportBelow(name: Breakpoint): boolean {
  return typeof window.matchMedia === 'function'
    ? window.matchMedia(belowQuery(name)).matches
    : window.innerWidth < breakpoints[name];
}
